@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/grid';

.accordion {
  $block: &;

  @include make-row;

  background-color: transparent;

  @media print {
    border: 1px solid palette.$black;
  }

  &--neutral {
    background-color: palette.$neutral50;

    #{$block}__icon,
    #{$block}__content {
      background-color: palette.$neutral50;
    }
  }

  &--white {
    background-color: palette.$white;

    #{$block}__icon,
    #{$block}__content {
      background-color: palette.$white;
    }
  }

  &--blueberry {
    background-color: palette.$blueberry50;

    #{$block}__icon,
    #{$block}__content {
      background-color: palette.$blueberry50;
    }
  }

  &--cherry {
    background-color: palette.$cherry50;

    #{$block}__icon,
    #{$block}__content {
      background-color: palette.$cherry50;
    }
  }

  &--medium#{&}--neutral,
  &--medium#{&}--blueberry,
  &--medium#{&}--cherry {
    @include media-breakpoint-up(md) {
      background-color: transparent;
    }
  }

  &__icon {
    @include make-col-ready;
    @include make-col(12);

    padding-top: spacers.getSpacer(s);
    padding-bottom: spacers.getSpacer(s);
  }

  &__content {
    @include make-col-ready;
    @include make-col(12);

    padding-top: spacers.getSpacer(l);
    padding-bottom: spacers.getSpacer(l);

    @include media-breakpoint-up(lg) {
      padding-top: spacers.getSpacer(xl);
      padding-bottom: spacers.getSpacer(xl);
    }
  }

  @include media-breakpoint-up(lg) {
    &__title {
      margin-bottom: spacers.getSpacer(l);
    }
  }

  &--medium#{&}--with-grid {
    #{$block}__icon,
    #{$block}__content {
      @include media-breakpoint-up(md) {
        @include make-col(10);
        @include make-col-offset(1);
      }

      @include media-breakpoint-up(lg) {
        @include make-col(8);
        @include make-col-offset(2);
      }
    }
  }

  &--medium,
  &--medium#{&}--with-grid {
    #{$block}__icon,
    #{$block}__content {
      @include media-breakpoint-up(md) {
        padding-left: spacers.getSpacer(m);
        padding-right: spacers.getSpacer(m);
      }

      @include media-breakpoint-up(lg) {
        padding-left: spacers.getSpacer(l);
        padding-right: spacers.getSpacer(l);
      }
    }
  }

  &--large#{&}--with-grid {
    #{$block}__icon {
      @include media-breakpoint-up(md) {
        @include make-col(10);
        @include make-col-offset(1);
      }

      @include media-breakpoint-up(lg) {
        @include make-col(2);
        @include make-col-offset(0);

        text-align: right;
      }
    }

    #{$block}__content {
      @include media-breakpoint-up(md) {
        @include make-col(10);
        @include make-col-offset(1);
      }

      @include media-breakpoint-up(lg) {
        @include make-col(8);
        @include make-col-offset(2);
      }
    }
  }

  &--large#{&},
  &--large#{&}--with-grid {
    #{$block}__icon {
      @include media-breakpoint-up(lg) {
        padding-top: spacers.getSpacer(m);
        padding-right: 1.25rem;
      }
    }
  }

  &--with-icon#{&}--with-grid#{&}--large {
    #{$block}__content {
      @include media-breakpoint-up(lg) {
        @include make-col-offset(0);

        padding-top: spacers.getSpacer(xl);
      }
    }
  }

  &--with-icon {
    #{$block}__content {
      padding-top: 0;
    }
  }
}
